var React = require('react');

function FlagBisexual (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_667_19039)","key":0},[React.createElement("rect",{"y":"0.333496","width":"32","height":"21.3333","fill":"white","key":0}),React.createElement("rect",{"y":"0.333496","width":"32","height":"8.53333","fill":"#D82F6C","key":1}),React.createElement("rect",{"y":"8.8667","width":"32","height":"4.26667","fill":"#6A5095","key":2}),React.createElement("rect",{"y":"13.1323","width":"32","height":"8.53333","fill":"#333F7C","key":3})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_667_19039"},React.createElement("rect",{"y":"0.333496","width":"32","height":"21.3333","rx":"2.13333","fill":"white"})))]);
}

FlagBisexual.defaultProps = {"width":"32","height":"22","viewBox":"0 0 32 22","fill":"none"};

module.exports = FlagBisexual;

FlagBisexual.default = FlagBisexual;
